@if (pageReady) {
  <main class="gs-page">
    <div class="service-agreements-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification></app-notification>
      </div>
      <div class="gs-content-container">
        @if (!isMobile) {
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="sortData($event)"
            class="mat-elevation-z8 desktop-table"
          >
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by address">
                {{ pageLabels.serviceAddressHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.Address1 }} {{ element.Address2 }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">
                {{ pageLabels.statusHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">
                @if (
                  accountDetail?.CustomerClass !== "LRGCOM" &&
                  element.SARenewalIndicator == "Y" &&
                  showRenewalRateChange(element.SaStatusFlag, element.BillingRateDescription)
                ) {
                  <a
                    class=""
                    [attr.aria-label]="pageLabels.rateRenewalLink.value.data.ariaLabel"
                    (click)="goToRateRenewal(element)"
                    >{{ pageLabels.rateRenewalLinkText }}</a
                  >
                } @else if (
                  accountDetail?.CustomerClass !== "LRGCOM" &&
                  element.BillingRate == "Variable" &&
                  showRenewalRateChange(element.SaStatusFlag, element.BillingRateDescription)
                ) {
                  <a
                    class=""
                    [attr.aria-label]="pageLabels.rateChangeLink.value.data.ariaLabel"
                    (click)="goToRateChange(element)"
                    >{{ pageLabels.rateChangeLinkText }}</a
                  >
                } @else if (
                  accountDetail?.CustomerClass !== "LRGCOM" &&
                  (element.SaStatusFlag === "60" || element.SaStatusFlag === "70") &&
                  elegibleForReconnect(element)
                ) {
                  <a
                    class=""
                    [attr.aria-label]="pageLabels.reconnectServiceLink.value.data.ariaLabel"
                    (click)="goToReconnect(element)"
                    >{{ pageLabels.reconnectLinkText }}</a
                  >
                } @else {
                  {{ element.SaStatusDescription }}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="plantype">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by plantype">
                {{ pageLabels.planTypeHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.SaRateScheduleCode }}</td>
            </ng-container>
            <ng-container matColumnDef="planprice">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by planprice">
                {{ pageLabels.planPriceHeaderText }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="plan-details-container"
                [innerHTML]="element.BillingRateDescription"
              ></td>
            </ng-container>
            <ng-container matColumnDef="turnondate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by turnondate">
                {{ pageLabels.turnOnDateHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">
                @if (element.SaStatusFlag !== "10") {
                  {{ element.SaStartDate }}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="turnoffdate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by turnoffdate">
                {{ pageLabels.turnOffDateHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">
                @if (
                  element.SaStatusFlag === "40" ||
                  element.SaStatusFlag === "60" ||
                  element.SaStatusFlag === "70" ||
                  accountDetail?.LandLordAlertIndicator === "Y"
                ) {
                  {{ element.SaEndDate }}
                } @else if (accountDetail?.CustomerClass !== "LRGCOM" && element.SaStatusFlag !== "10") {
                  <a [attr.aria-label]="pageLabels.stopServiceLink.value.data.ariaLabel" (click)="goToStop(element)">{{
                    pageLabels.stopServiceLinkText
                  }}</a>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="enddate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by enddate">
                {{ pageLabels.contractEndsHeaderText }}
              </th>
              <td mat-cell *matCellDef="let element">
                @if (
                  (element.SaStatusFlag === "20" || element.SaStatusFlag === "50") &&
                  (element.SaRateScheduleCode === "Fixed" || element.SaRateScheduleCode === "OnePrice Plan")
                ) {
                  {{ element.BillingRateExpirationDate }}
                }
              </td>
              <ng-container matColumnDef="transfer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by transfer">
                  {{ pageLabels.transferHeaderText }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (
                    (element.SaStatusFlag === "20" || element.SaStatusFlag === "50") &&
                    accountDetail?.CustomerClass !== "LRGCOM" &&
                    accountDetail?.LandLordAlertIndicator !== "Y"
                  ) {
                    <a
                      [attr.aria-label]="pageLabels.moveServiceLink.value.data.ariaLabel"
                      (click)="goToTransfer(element)"
                      >{{ pageLabels.transferLinkText }}</a
                    >
                  }
                </td>
              </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        } @else {
          @if (serviceAgreements !== null && serviceAgreements.length !== 0) {
            <div class="mobile-sort-btns">
              <button
                type="button"
                mat-flat-button
                class="gs-form-button-primary filter-btn"
                [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu"
                color="primary"
              >
                Sort
              </button>
              <button
                type="button"
                mat-flat-button
                class="gs-form-button-primary clear-btn"
                aria-label="Example icon-button with a menu"
                color="primary"
                (click)="mobileSortData('clear')"
              >
                Clear
              </button>
            </div>
          }
          <mat-menu #menu="matMenu" class="mobile-filter" xPosition="before">
            <button mat-menu-item [matMenuTriggerFor]="status">{{ pageLabels.statusHeaderText }}</button>
          </mat-menu>
          <mat-menu #status="matMenu">
            <button mat-menu-item (click)="mobileSortData('pending start')">Pending Start</button>
            <button mat-menu-item (click)="mobileSortData('active')">Active</button>
            <button mat-menu-item (click)="mobileSortData('stopped')">Stopped</button>
            <button mat-menu-item (click)="mobileSortData('closed')">Closed</button>
          </mat-menu>
          <mat-accordion class="mobile-cards">
            @for (element of mobileServiceAgreements; track $index) {
              <mat-expansion-panel (click)="setOpenMobilePanelIndex($index)">
                <mat-expansion-panel-header class="mobile-expansion-header">
                  <mat-panel-title class="expansion-title">
                    <h3 class="h3">{{ element.Address1 }} {{ element.Address2 }}</h3>
                    @if (mobilePanelIndex !== $index) {
                      @if (element.SaStatusFlag === "10") {
                        <div>Pending Start</div>
                      } @else if (element.SaStatusFlag === "20" || element.SaStatusFlag === "50") {
                        <div>Active</div>
                      } @else if (element.SaStatusFlag === "40") {
                        <div>Stopped</div>
                      } @else if (element.SaStatusFlag === "60" || element.SaStatusFlag === "70") {
                        <div>Closed</div>
                      }
                    }
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="mobile-card-content">
                  <div class="mobile-plan-detail">
                    <p class="mobile-card-labels">{{ pageLabels.statusHeaderText }}</p>
                    <p>
                      @if (
                        element.SARenewalIndicator === "Y" &&
                        accountDetail?.CustomerClass !== "LRGCOM" &&
                        showRenewalRateChange(element.SaStatusFlag!, element.BillingRateDescription!)
                      ) {
                        <a
                          class=""
                          [attr.aria-label]="pageLabels.rateRenewalLink.value.data.ariaLabel"
                          (click)="goToRateRenewal(element)"
                          >{{ pageLabels.rateRenewalLinkText }}</a
                        >
                      } @else if (
                        element.BillingRateValue === "Variable" &&
                        accountDetail?.CustomerClass !== "LRGCOM" &&
                        showRenewalRateChange(element.SaStatusFlag!, element.BillingRateDescription!)
                      ) {
                        <a
                          class=""
                          [attr.aria-label]="pageLabels.rateChangeLink.value.data.ariaLabel"
                          (click)="goToRateChange(element)"
                          >{{ pageLabels.rateChangeLinkText }}</a
                        >
                      } @else {
                        {{ element.SaStatusDescription }}
                      }
                    </p>
                  </div>
                  <div class="mobile-plan-detail">
                    <p class="mobile-card-labels">
                      {{ pageLabels.planTypeHeaderText }}
                    </p>
                    <p>{{ element.SaRateScheduleCode }}</p>
                  </div>
                  <div class="mobile-plan-detail">
                    <p class="mobile-card-labels">
                      {{ pageLabels.planPriceHeaderText }}
                    </p>
                    <p class="plan-details-container" [innerHTML]="element.BillingRateDescription"></p>
                  </div>
                  @if (
                    (element.SaStatusFlag === "20" || element.SaStatusFlag === "50") &&
                    (element.SaRateScheduleCode === "Fixed" || element.SaRateScheduleCode === "OnePrice Plan")
                  ) {
                    <div class="mobile-plan-detail">
                      <p class="mobile-card-labels">
                        {{ pageLabels.contractEndsHeaderText }}
                      </p>
                      <p>
                        {{ element.BillingRateExpirationDate }}
                      </p>
                    </div>
                  }
                  @if (element.SaStartDate !== "" && element.SaStatusFlag !== "10") {
                    <div class="mobile-plan-detail">
                      <p class="mobile-card-labels">
                        {{ pageLabels.turnOnDateHeaderText }}
                      </p>
                      <p>{{ element.SaStartDate }}</p>
                    </div>
                  }
                  @if (
                    element.SaStatusFlag === "40" ||
                    element.SaStatusFlag === "60" ||
                    element.SaStatusFlag === "70" ||
                    accountDetail?.LandLordAlertIndicator === "Y"
                  ) {
                    <div class="mobile-plan-detail">
                      <p class="mobile-card-labels">
                        {{ pageLabels.turnOffDateHeaderText }}
                      </p>
                      <p>
                        {{ element.SaEndDate }}
                      </p>
                    </div>
                  } @else if (
                    accountDetail?.CustomerClass !== "LRGCOM" &&
                    accountDetail?.LandLordAlertIndicator !== "Y" &&
                    element.SaStatusFlag !== "10"
                  ) {
                    <div class="mobile-plan-detail">
                      <p class="mobile-card-labels">
                        {{ pageLabels.turnOffDateHeaderText }}
                      </p>
                      <a
                        [attr.aria-label]="pageLabels.stopServiceLink.value.data.ariaLabel"
                        (click)="goToStop(element)"
                        >{{ pageLabels.stopServiceLinkText }}</a
                      >
                    </div>
                  }
                  @if (
                    accountDetail?.CustomerClass !== "LRGCOM" &&
                    accountDetail?.LandLordAlertIndicator !== "Y" &&
                    (element.SaStatusFlag === "20" || element.SaStatusFlag === "50")
                  ) {
                    <div class="mobile-plan-detail">
                      <p class="mobile-card-labels">
                        {{ pageLabels.transferHeaderText }}
                      </p>
                      <p>
                        <a
                          [attr.aria-label]="pageLabels.moveServiceLink.value.data.ariaLabel"
                          (click)="goToTransfer(element)"
                          >{{ pageLabels.transferLinkText }}</a
                        >
                      </p>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
        @if (length && length > pageSize) {
          <mat-paginator
            (page)="handlePageEvent($event)"
            [length]="dataSource.length"
            [pageSize]="pageSize"
            [showFirstLastButtons]="showFirstLastButtons"
            aria-label="Select page"
          ></mat-paginator>
        }
      </div>
    </div>
  </main>
}
